export default {
    reset_company_auth_title: "Restablecer la autenticación de Cognito",
    reset_company_auth_success_message: "La autenticación de Cognito se ha restablecido",
    reset_company_auth_error_message: "La autenticación de Cognito no se ha podido restablecer debido a un error",
    reset_company_auth_message: "¿Desea restablecer la autenticación de Cognito?",
    reset_company_auth_label: "Restablecer",
};